var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShipmentsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 11.25h9.625l-7.125-6c-.25-.125-.625-.25-.875-.25h-4zm.375 2.5v8.75H15v-8.75H5v20C5 34.5 5.5 35 6.25 35h27.5c.75 0 1.25-.5 1.25-1.25v-20zm-9.625-2.5L17.75 5h-4c-.25 0-.625.125-.75.25l-7.25 6z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShipmentsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shipments-icon.4b3eed7ebd8144585350da88c992bb7b.svg";